var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/Check Circle",
    clipPath: "url(#clip0_1171_56104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7166 4.07791C11.9892 4.23698 12.0812 4.5869 11.9221 4.85947L8.25372 11.1448C8.1712 11.2866 8.05913 11.4089 7.92514 11.5035C7.79208 11.5974 7.64049 11.6618 7.48055 11.6923C7.31861 11.7244 7.15156 11.7203 6.99137 11.6802C6.83145 11.6403 6.68234 11.5655 6.55468 11.4612L4.21446 9.58907C3.96802 9.39192 3.92807 9.03232 4.12522 8.78589C4.32237 8.53945 4.68196 8.4995 4.9284 8.69665L7.26727 10.5677L10.935 4.28339C11.0941 4.01083 11.444 3.91883 11.7166 4.07791Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.14286C4.2129 1.14286 1.14286 4.2129 1.14286 8C1.14286 11.7871 4.2129 14.8571 8 14.8571C11.7871 14.8571 14.8571 11.7871 14.8571 8C14.8571 4.2129 11.7871 1.14286 8 1.14286ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#1A1A1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1171_56104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.0d0981a13a76c6e4734e854bec06d409.svg";
export { ForwardRef as ReactComponent };